import React from 'react';

// Base
import Avatar from '../../../../../base/avatar';
import Card from '../../../../../base/card';
import Col from '../../../../../base/col';
import Placeholder from '../../../../../base/placeholder';
import Row from '../../../../../base/row';
import Separator from '../../../../../base/separator';

export default class Loading extends React.PureComponent {
  render() {
    return (
      <Row className='margin-top-15 margin-bottom-10' nested>
        <Col s={12} className='med-font dark margin-bottom-10'>
          Education
        </Col>
        {
          [...Array(2)].map((_, i) => (
            <Col s={12} key={i}>
              <Card
                border='thin'
                className='min-height-0 margin-bottom-10'
              >
                <div className='flex'>
                  <div>
                    <Avatar {...{
                      size: 'sm',
                      isOrganization: true,
                    }} />
                  </div>
                  <div className='flex-row margin-left-10 flex-grow-1'>
                    <Placeholder lines={3} />
                  </div>
                </div>
              </Card>
            </Col>
          ))
        }
      </Row>
    )
  }
}